import React, { useRef, useEffect } from 'react';

const SourcesInfoTooltip: React.FC = () => {
  const svgRef = useRef<SVGSVGElement>(null);
  useEffect(() => { $(svgRef.current).popover(); }, []);

  return (
    <svg
      className="icon icon-sm"
      ref={svgRef}
      data-toggle="popover"
      data-trigger="hover"
      data-content="Specialist has left you a comment."
      data-placement="right"
    >
      <use xlinkHref="#icon-mortar-hat" />
    </svg>
  );
};

export default SourcesInfoTooltip;
